module.exports = __webpack_public_path__ + "static/360view-2-f29644c18d01e74432171610c13a152b.jpg";